import React, { useState } from "react";
import "../../styles/login_register.scss";
import banner from "../../imagens/banner.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;

const Login = () => {
  const [LOGIN, setLOGIN] = useState("");
  const [password, setPassword] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [overwriteData, setOverwriteData] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();

    try {
      const loginData = { LOGIN, password };
      const response = await axios.post(`${API_URL}/api/auth/login`, loginData, {
        withCredentials: true,
      });

      // Processa o sucesso do login
      const { token, idEmpresa } = response.data;
      localStorage.setItem("authToken", token);
      localStorage.setItem("idEmpresa", idEmpresa);
      toast.success("Login realizado com sucesso!");

      setTimeout(() => {
        navigate("/dashs");
      }, 100); // Adiciona um pequeno delay


      navigate("/dashs");
      
      //console.log("Token Salvo apos login: ",localStorage.getItem("authToken"));

    } catch (error) {
      if (
        error.response?.status === 400 &&
        error.response?.data?.overwriteOption
      ) {
        setShowPopup(true);
        setPopupMessage(
          "Usuario conectado em outra sessão, não é permitido compartilhamento de logins e/ou logins simulteneos, contate o administrador. deseja sobrescrever o usuario logado?"
        );
        setOverwriteData({ LOGIN, password });
      } else {
        toast.error(error.response?.data?.error || "Erro ao realizar login.");
      }
    }
  };

  const handleOverwriteSession = async () => {
    setShowPopup(false);

    try {
      const response = await axios.post(
        `${API_URL}/api/auth/overwriteSession`,
        overwriteData,
        {
          withCredentials: true,
        }
      );

      const { token, idEmpresa } = response.data;



      localStorage.setItem("authToken", token);
      localStorage.setItem("idEmpresa", idEmpresa);

      // console.log("Token salvo no localStorage:", token);
      // console.log("Token salvo no localStorage, navegando para /dashs...");
      // console.log("Navegando para /dashs...");

      toast.success("Sessão sobrescrita com sucesso!");
     
        navigate("/dashs");
        // console.log("Redirecionamento inalizado.");
        // console.log("Token Salvo apos sobrescrever",localStorage.getItem("authToken"));


    } catch (error) {
      toast.error(
        error.response?.data?.error || "Erro ao sobrescrever a sessão."
      );
    }
  };

  return (
    <div className="limiter">
      <div className="container-login100">
        <div className="wrap-login100">
          <div
            className="login100-form-title"
            style={{ backgroundImage: `url(${banner})` }}
          ></div>

          <form className="login100-form validate-form" onSubmit={handleLogin}>
            <div className="wrap-input100 m-b-26 no-border">
              <span className="label-input100">Usuário</span>
              <input
                className="input100"
                type="text"
                placeholder="Entre com seu e-mail"
                value={LOGIN}
                onChange={(e) => setLOGIN(e.target.value)}
              />
            </div>
            <div className="wrap-input100 m-b-18">
              <span className="label-input100">Senha</span>
              <input
                className="input100"
                type="password"
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="container-login100-form-btn">
              <button className="login100-form-btn" type="submit">
                Entrar
              </button>
            </div>
          </form>
        </div>
      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{popupMessage}</p>
            <button onClick={handleOverwriteSession}>Sobrescrever</button>
            <button onClick={() => setShowPopup(false)}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
